/* eslint-disable */
export default {
  add: 'Add',
  noCalls: 'No available calls',
  activeCall: 'Active Call',
} as const;

// @key: @#@"add"@#@ @source: @#@"Add"@#@
// @key: @#@"noCalls"@#@ @source: @#@"No available calls"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
